import Step1 from './Step1';
import './Step1.scss';

export default Step1;